/**
 * Brand icons for email-sending providers used in Settings.
 * Sized via the `className` prop (defaults to h-6 w-6). Colours are baked into
 * the SVG so they stay on-brand regardless of surrounding text colour.
 */

interface IconProps {
  className?: string;
}

/** Official multicolour Gmail logo. */
export const GmailIcon = ({ className = 'h-6 w-6' }: IconProps) => (
  <svg
    className={className}
    viewBox="0 0 256 193"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fill="#4285F4"
      d="M58.182 192.05V93.14L27.507 65.077 0 49.504v125.091c0 9.658 7.825 17.455 17.455 17.455z"
    />
    <path
      fill="#34A853"
      d="M197.818 192.05h40.727c9.659 0 17.455-7.826 17.455-17.455V49.505l-31.156 17.837-27.026 25.798z"
    />
    <path
      fill="#EA4335"
      d="m58.182 93.14-4.174-38.647 4.174-36.989L128 69.868l69.818-52.364 4.669 34.992-4.669 40.644L128 145.504z"
    />
    <path
      fill="#FBBC04"
      d="M197.818 17.504V93.14L256 49.504V26.231c0-21.585-24.64-33.89-41.89-20.945z"
    />
    <path
      fill="#C5221F"
      d="M0 49.504l26.759 20.07L58.182 93.14V17.504L41.89 5.286C24.61-7.66 0 4.646 0 26.231z"
    />
  </svg>
);

/** Microsoft Outlook mark: blue mail card with the signature white "O" tile. */
export const OutlookIcon = ({ className = 'h-6 w-6' }: IconProps) => (
  <svg
    className={className}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {/* Mail card */}
    <path
      fill="#1976D2"
      d="M44 14.5v19a1.5 1.5 0 0 1-1.5 1.5H22V13h20.5A1.5 1.5 0 0 1 44 14.5z"
    />
    <rect x="24" y="17" width="18" height="14" fill="#fff" />
    <path fill="#1976D2" d="M24 17h18l-9 6.4z" />
    <path fill="#1565C0" d="M24 31l9-6.6 9 6.6V33.5A1.5 1.5 0 0 1 40.5 35H24z" />
    {/* The "O" tile */}
    <path
      fill="#0D47A1"
      d="M6 9.8 26 6.4v35.2L6 38.2A2 2 0 0 1 4 36.2V11.8a2 2 0 0 1 2-2z"
    />
    <path
      fill="#fff"
      d="M15.2 16.6c-3.4 0-5.7 3-5.7 7.4s2.3 7.4 5.7 7.4 5.7-3 5.7-7.4-2.3-7.4-5.7-7.4zm0 12c-1.8 0-3-1.9-3-4.6s1.2-4.6 3-4.6 3 1.9 3 4.6-1.2 4.6-3 4.6z"
    />
  </svg>
);
